export default __webpack_public_path__ + "static/media/art.fa9301f3.jpg";